module.exports = __webpack_public_path__ + "img/IMG_1425.849cea6b.jpg";